<template>
  <div class="cloud-search">
    <!-- pc -->
    <b-form class="tw-hidden md:tw-block">
      <div class="tw-flex tw-items-center tw-gap-4">
        <p class="tw-text-textInfo">{{ $t("倒计时长") }}</p>
        <ul class="tw-flex tw-gap-4 lg:tw-gap-6 tw-mb-6">
          <li
            v-for="tab in tabsList"
            :key="tab.name"
            class="tabs-list tw-cursor-pointer tw-border tw-border-mdivider tw-px-2 tw-py-1 tw-text-textDisabled"
            :class="{
              'tabs-active': activeTabs === tab.name,
            }"
            @click="onChangeMenu(tab.name)"
          >
            {{ tab.title }}
          </li>
        </ul>
      </div>
      <b-row :cols="12" class="g-2">
        <b-col cols="3" class="m-0 mb-3">
          <div class="tw-flex tw-items-center tw-gap-3">
            <label
              for="order-input"
              class="text-sm tw-text-textInfo font-medium flex-shrink-0"
              >{{ $t("实例ID") }}</label
            >
            <b-form-input
              id="order-input"
              v-model="form.id"
              size="sm"
              :placeholder="$t('请输入')"
              class="flex-grow"
            ></b-form-input>
          </div>
        </b-col>
        <b-col cols="3" class="m-0 mb-3">
          <div class="tw-flex tw-items-center tw-gap-3">
            <label
              for="order-input"
              class="tw-text-sm tw-text-textInfo font-medium flex-shrink-0"
              >{{ $t("实例状态") }}</label
            >
            <CustomSelect v-model="form.status" :options="options" size="sm" />
          </div>
        </b-col>
        <b-col cols="3">
          <div class="tw-flex tw-items-center tw-gap-3">
            <b-button size="sm" variant="primary" @click="onSearch">{{
              $t("搜索")
            }}</b-button>
            <b-button size="sm" variant="primary" @click="onReset">{{
              $t("重置")
            }}</b-button>

            <b-button
              size="sm"
              variant="primary"
              @click="onSearch"
              style="
                border-radius: 50%;
                height: 31px;
                display: flex;
                align-items: center;
              "
            >
              <b-icon
                icon="arrow-clockwise"
                style="width: 14px; height: 14px"
              ></b-icon>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>

    <!-- 移动 -->
    <b-form class="md:tw-hidden tw-block">
      <b-row class="g-2">
        <b-col cols="7" class="m-0 mb-3">
          <div class="tw-flex tw-items-center tw-gap-3">
            <p class="tw-text-textInfo tw-text-sm tw-whitespace-nowrap tw-mb-0">
              {{ $t("分类") }}
            </p>
            <CustomSelect
              v-model="categoryId"
              :options="menuList"
              valueField="id"
              labelField="name"
              @select="handleSelectCategory"
              size="sm"
            />
          </div>
        </b-col>
        <b-col cols="5" class="m-0 mb-3 p-0">
          <div class="tw-flex tw-items-center tw-gap-3">
            <div class="tw-text-sm tw-whitespace-nowrap">
              {{ $t("倒计时长") }}:
            </div>
            <b-dropdown
              id="time-filter-dropdown"
              variant="light"
              :text="$t(activeTabs)"
              right
              class="time-filter-dropdown"
              size="sm"
            >
              <b-dropdown-item
                v-for="im in tabsList"
                :key="im.name"
                @click="onChangeMenu(im.name)"
                :active="activeTabs == im.name"
              >
                {{ $t(im.title) }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="7" class="m-0 mb-3">
          <div class="tw-flex tw-items-center tw-gap-3">
            <label
              for="order-input"
              class="tw-text-sm tw-text-textInfo font-medium flex-shrink-0"
              >{{ $t("实例状态") }}</label
            >
            <CustomSelect v-model="form.status" :options="options" size="sm" />
          </div>
        </b-col>
        <b-col cols="5" class="p-0">
          <div class="tw-flex tw-items-center tw-gap-3">
            <b-button size="sm" variant="primary" @click="onSearch">{{
              $t("搜索")
            }}</b-button>
            <b-button size="sm" variant="primary" @click="onReset">{{
              $t("重置")
            }}</b-button>

            <div class="tw-hidden md:tw-block">
              <b-button
                size="sm"
                variant="primary"
                @click="onSearch"
                style="
                  border-radius: 50%;
                  height: 31px;
                  display: flex;
                  align-items: center;
                "
              >
                <b-icon
                  icon="arrow-clockwise"
                  style="width: 14px; height: 14px"
                ></b-icon>
              </b-button>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import dayjs from "dayjs";
import CustomSelect from "@/components/CustomSelect.vue";
import { productsApi } from "@/api/modules/home";
export default {
  name: "cloud-search",
  components: {
    CustomSelect,
  },
  data() {
    return {
      activeTabs: "全部",
      tabsList: [
        { name: "全部", title: this.$t("全部") },
        { name: "7天内", title: this.$t("7天内") },
        { name: "15天内", title: this.$t("15天内") },
        { name: "30天内", title: this.$t("30天内") },
        { name: "2个月内", title: this.$t("2个月内") },
      ],
      menuList: [],
      // 默认选择第一个
      activeMenu: "",
      form: {
        id: "",
        status: "",
        // 到期时间开始
        expireTimeStart: "",
        // 到期时间结束
        expireTimeEnd: "",
      },
      categoryId: "",
      options: [
        {
          value: "1",
          text: "运行中",
        },
        {
          value: "2",
          text: "已停止",
        },
        {
          value: "3",
          text: "已过期 ",
        },
        {
          value: "4",
          text: "创建中",
        },
      ],
    };
  },
  watch: {
    // 监听路由参数变化
    "$route.params.id": {
      handler(newId) {
        // 仅在移动端且路由参数变化时更新
        if (!this.$screen.md && newId) {
          this.categoryId = Number(newId);
          this.activeMenu = Number(newId);
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getList();
  },
  methods: {
    // 方法区
    async getList() {
      let params = {
        pageIndex: 1,
        pageSize: 20,
        property: 3,
      };
      const { code, data } = await productsApi(params);
      if (code !== 0) return;
      // 获取前5条数据

      this.menuList = data?.list || [];
    },
    // 根据选择设置到期时间范围
    setExpireTimeRange(range) {
      // 先重置时间范围
      this.form.expireTimeStart = "";
      this.form.expireTimeEnd = "";

      if (range === "全部") {
        // 全部则不设置时间范围
        return;
      }

      const now = dayjs();

      // 设置开始时间为当前时间
      this.form.expireTimeStart = now.toISOString();

      let endDate;
      if (range === "7天内") {
        endDate = now.add(7, "day");
      } else if (range === "15天内") {
        endDate = now.add(15, "day");
      } else if (range === "30天内") {
        endDate = now.add(30, "day");
      } else if (range === "2个月内") {
        endDate = now.add(2, "month");
      }
      this.form.expireTimeEnd = endDate.toISOString();
    },

    // 切换tab
    onChangeMenu(name) {
      this.activeTabs = name;
      this.setExpireTimeRange(name);
      this.onSearch();
    },

    // 搜索
    onSearch() {
      this.$emit("search", { ...this.form });
    },
    handleSelectCategory(item) {
      this.$router.push(`/cloudWord/cloud-server/${item.id}`);
    },

    // 重置
    onReset() {
      // 重置表单
      this.form = {
        id: "",
        status: "",
        expireTimeStart: "",
        expireTimeEnd: "",
      };

      this.activeTabs = "全部";
      if (!this.$screen.md) {
        // 移动端保留路由参数中的 categoryId
        const categoryId = Number(this.$route.params.id);
        if (categoryId) {
          this.categoryId = categoryId;
          this.activeMenu = categoryId;
        }
      } else {
        // PC端恢复默认菜单选择
        this.activeMenu = this.menuList[0]?.id || "";
        this.categoryId = "";
      }

      this.$emit("reset");
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs-list {
  font-size: 14px;
  width: 90px;
  border-radius: 0.2rem;
  text-align: center;
}

.tabs-active {
  @apply tw-text-primary tw-border-primary;
  background: rgba(64, 119, 248, 0.1);
}

::v-deep label {
  margin: 0;
}
</style>
